
export const HeaderContent = [
    {
        id: 1,
        titre: "ACCUEIL",
        link: "/home#header"
    },
    {
        id: 2,
        titre: "CARTE",
        link: "/home/carte"
    },
    {
        id: 3,
        titre: "TRAITEUR",
        link: "/home#traiteur"
    },
    {
        id: 4,
        titre: "CONTACT",
        link: "/home/contact-form"
    },
    {
        id: 5,
        titre: "GALERIE",
        link: "/home/gallerie"
    }
]


export const HeaderContentMobile = [
    {
        id: 1,
        titre: "ACCUEIL",
        link: "/home#header"
    },
    {
        id: 2,
        titre: "CARTE",
        link: "/home/carte"
    },
    {
        id: 3,
        titre: "TRAITEUR",
        link: "/home#traiteur"
    },
    {
        id: 4,
        titre: "CONTACT",
        link: "/home/contact-form"
    },
    {
        id: 5,
        titre: "GALERIE",
        link: "/home/gallerie"
    },
    {
        id: 5,
        titre: "PANIER",
        link: "/home/panier"
    }
]